<template>
<div class="tableWithPerPageSelection">
  <div class="entete border-entete">
    <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3" >
                {{ $t('listeOperationDiverse.title') }}
                </h1>
                <app-breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="buttons">
              <button
                class="button is-addOrEdit"
                :class="{'button-access-no-permission' :
                !checkPermissions(permOperationDiverse.maj)}"
                @click="checkPermissions(permOperationDiverse.maj) ?
                $router.push({ name: 'm.comptabilite.operation_diverse-add' }) : showPopUp()">
                {{ $t('listeOperationDiverse.actions.add')}}
              </button>
            </div>
          </div>
        </div>
    </div>
    </div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-action
              @handleAction="manageActions"
              :options='actions'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="getAllOdSelected().length > 0"
            ></selecteur-action>
          </div>
          <form @submit.prevent="recherche()"
                class="column is-narrow">
            <b-input :placeholder="$t('listeOperationDiverse.actions.search')"
                    type="search" icon="magnify" v-model="critereRecherche.auto">
            </b-input>
          </form>
          <div class='column is-narrow'>
            <button class="button" @click='setShowFiltre'>
               <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
                 <span class="is-size-7">
                    {{ $t('general.filtre.title') }}
                  <label class="has-text-weight-bold"
                        :class="nombreCritere > 0 ? '' : 'is-invisible'">
                    ({{ nombreCritere }})
                  </label>
               </span>
            </button>
            <span @click="reinitialiserFiltre()"
                class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="columns level-right">
        <div class="column is-narrow">
          <exportExcelButton
            :perm="permOperationDiverse.exporter"
            :query="exportExcelQuery"/>
        </div>
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <v-server-table url="" :columns="columns" :options="options" :ref="referenceTable"
                    @loaded="finLoading" @loading="debutLoading" v-if="startArrayRendering"
                    class='tableWithChildRow'>
    <template slot='afterTable'>
      <table-items-in-view
        :perPage="resultPerPage"
        @input="$refs[referenceTable].setLimit($event)"/>
    </template>
    <div slot="selected" slot-scope="props" class="has-text-centered">
        <b-checkbox v-model="props.row.selected" :value="props.row">
        </b-checkbox>
    </div>
    <div slot="libelle" slot-scope="props">
      <router-link :to="{ name: 'c.comptabilite.operation_diverse',
                    params: {id: props.row.id} }"
                    class="has-background-transparent lien"
                    :class="{'text-access-no-permission':
                    !checkPermissions(permOperationDiverse.lecture)}">
        {{ props.row.mouvementOd.libelle }}
      </router-link>
    </div>
    <div slot="dateMouvement" slot-scope="props">
        {{ props.row.mouvementOd.dateMouvement | formatDate }}
    </div>
    <div slot="credit" slot-scope="props" class="is-pulled-right">
        {{ props.row.mouvementOd.credit | formatDevise }}
    </div>
    <div slot="debit" slot-scope="props" class="is-pulled-right">
        {{ props.row.mouvementOd.debit | formatDevise }}
    </div>
    <div slot="etat" slot-scope="props">
        {{ $t(getEtat(props.row.etat)) }}
    </div>
    <div slot="tiers" slot-scope="props">
      <router-link-blank v-if="isClient(props.row.mouvementOd.tiers)"
        :message="props.row.mouvementOd.tiers.nomCommercial "
        :to="{ name: 'c.bodac.clients/contacts-client',
        params: {id: props.row.mouvementOd.tiersId}}">
      </router-link-blank>
      <router-link-blank v-else
        :message="props.row.mouvementOd.tiers.nomCommercial"
        :to="{ name: 'c.baux.bailleur',
        params: {id: props.row.mouvementOd.tiersId}}">
      </router-link-blank>
    </div>
    <div slot="compteComptable" slot-scope="props">
        {{ props.row.mouvementOd.tiers.compteComptable }}
    </div>

    <div slot="montant" slot-scope="props" class="right">
        {{ getMontant(props.row.ifEcritures) | formatDevise }}
    </div>
      <div slot="edit" slot-scope="props" class="has-text-centered">
        <router-link
          :to="{ name: 'm.comptabilite.operation_diverse-edit', params: {id: props.row.id}}"
          :class="{ 'disabled': props.row.etat === constantes.VALIDE
          }">
          <b-icon
            icon="pencil-box-outline"
            type="is-success"
            :class="{ 'text-access-no-permission' : props.row.etat === constantes.VALIDE
             || !checkPermissions(permOperationDiverse.maj) }"
          >
          </b-icon>
        </router-link>
      </div>
      <div slot="supprimer" class="has-text-centered" slot-scope="props">
        <div @click="checkPermissions(permOperationDiverse.supprimer) ? openPopUpDelete(props.row) :
            showPopUp()"
             :class="{'disabled': props.row.etat === constantes.VALIDE }"
             class="is-cursor-pointer">
          <b-icon icon="delete-forever"
                  :type="{ 'is-danger': props.row.etat !== constantes.VALIDE }"
                  :class="{ 'text-access-no-permission' :
                      !checkPermissions(permOperationDiverse.supprimer) }"
          ></b-icon>
        </div>
      </div>
    </v-server-table>
    <div class="componentBrief" v-show="showFiltre === true">
      <filtre-liste-operation-diverse ref="filtreListeOperationDiverse"
                    @toggleFiltre="setShowFiltre"
                    v-model="critereRecherche"
                    @recherche="makeRechercheFilter"/>
    </div>
    <b-modal v-model="popUpSuppression" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="idToDelete.length === 1
          ? this.$t('listeOperationDiverse.popUpSuppression.title')
          : this.$t('listeOperationDiverse.popUpSuppression.titleMulti')"
        :cancel="this.$t('general.non')"
        :validate="this.$t('general.oui')"
        :messagesPopup="messagesPopUp"
        :isErrorPopup.sync="isErrorPopUp"
        @no="popUpSuppression = false"
        @yes="deleteOdMass()"/>
    </b-modal>
</div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import breadcrumb from '@/components/general/breadcrumb';
import messageErreur from '@/services/general/messageErreur';
import {
  TEXTS, RESULTS_PER_PAGE, SORT_ICON, NO_PER_PAGE_VALUE,
} from '@/configuration/clientTableConf';
import filtreListeOperationDiverse from '@/components/compta/operationDiverse/filtreListeOperationDiverse';
import TableItemsInView from '@/components/general/TableItemsInView';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import subscribeMutation from '@/services/store/subscribeMutation';
import { OPERATION_DIVERSE } from '@/configuration/compta/permissionsComptaConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import cloneDeep from 'lodash/cloneDeep';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import formatIsoDate from '@/services/general/formatIsoDate';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import { EXPORT_EXCEL_OD, LISTE_ETAT_OD, VALIDE } from '@/configuration/compta/odConfig';
import transform from '@/services/compta/operationDiverse/operationDiverseServerTableDataTransformer';
import { deleteAll } from '@/api/compta/operationDiverse/index';
import { ACTION_MASS_DELETE } from '@/configuration/general/actionsConf';
import messageSucces from '@/services/general/messageSucces';
import validation from '@/services/compta/operationDiverse/validation/validation';
import popUpPrevention from '@/components/general/popUpPrevention';
import selecteurAction from '@/components/general/selecteurAction';
import { TIERS_SOUS_TYPE_AUCUN } from '@/configuration/tiers/tiersConf';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_OPERATION_DIVERSE } from '@/configuration/general/referenceTableConf';

const societe = createNamespacedHelpers('societe');
const operationDiverse = createNamespacedHelpers('operationDiverse');
const Permissions = createNamespacedHelpers('permissions');

export default {
  data() {
    return {
      actions: [
        { action: ACTION_MASS_DELETE, translation: 'general.button.delete' },
      ],
      showFiltre: false,
      isErrorPopUp: false,
      messagesPopUp: [],
      permOperationDiverse: OPERATION_DIVERSE,
      unsubscribeValue: null,
      constantes: {
        VALIDE,
      },
      popUpSuppression: false,
      idToDelete: [],
      startArrayRendering: false,
      referenceTable: REFERENCE_TABLE_OPERATION_DIVERSE,
      resultPerPage: RESULTS_PER_PAGE,
    };
  },
  beforeDestroy() {
    if (this.lockMenu) this.setLockMenu(false);
    this.unsubscribeValue();
  },
  components: {
    AppBreadcrumb: breadcrumb,
    filtreListeOperationDiverse,
    TableItemsInView,
    routerLinkBlank,
    popUpPrevention,
    selecteurAction,
    parametrageTable,
    exportExcelButton,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('listeOperationDiverse.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeOperationDiverse.title'), route: '', isActive: true },
      ];
      return output;
    },
    ...operationDiverse.mapGetters({
      items: 'items',
      totalCount: 'totalCount',
      critereRecherche: 'criteresRecherche',
      lastPayload: 'lastPayload',
    }),
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
      lockMenu: 'lockMenu',
    }),
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          libelle: this.$t('listeOperationDiverse.tab.libelle'),
          compteComptable: this.$t('listeOperationDiverse.tab.compteComptable'),
          dateMouvement: this.$t('listeOperationDiverse.tab.dateMouvement'),
          debit: this.$t('listeOperationDiverse.tab.debit'),
          credit: this.$t('listeOperationDiverse.tab.credit'),
          tiers: this.$t('listeOperationDiverse.tab.tiers'),
          etat: this.$t('listeOperationDiverse.tab.etat'),
          edit: '',
          supprimer: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        requestFunction: ((data) => {
          data.query = cloneDeep(this.critereRecherche);
          if (data.query.tiers.length > 0) {
            data.query.tiersIds = data.query.tiers.map((tiers) => tiers.id);
            delete data.query.tiers;
          }
          data.query.dates.dateDebut = formatIsoDate(data.query.dates.dateDebut);
          data.query.dates.dateFin = formatIsoDate(data.query.dates.dateFin);
          data.query.societeId = this.societeActiveId;
          return this.actionsloadOperationDiverse(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.items,
            count: this.totalCount,
          };
        }),
        sortable: ['libelle', 'tiers', 'compteComptable', 'dateMouvement', 'debit', 'credit'],
        columnsClasses: {
          selected: 'colonneSelected',
          supprimer: 'colonneSelected',
          edit: 'colonneSelected',
        },
      };
    },
    columns() {
      return ['selected', 'libelle', 'tiers', 'compteComptable', 'dateMouvement', 'etat', 'debit', 'credit', 'edit', 'supprimer'];
    },
    nombreCritere() {
      const banCritereKey = ['auto', 'dates'];
      let nombreCritere = calculNombreCritere(this.critereRecherche, banCritereKey);
      if (this.critereRecherche.dates.dateDebut
        || this.critereRecherche.dates.dateFin) nombreCritere += 1;
      return nombreCritere <= 9 ? nombreCritere : '+9';
    },
    iconSelectTotal() {
      if (this.allOdSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    allOdSelected() {
      return this.getAllOdSelected().length === this.items.length
        && this.items.length > 0;
    },
    exportExcelQuery() {
      return {
        typeDonnee: EXPORT_EXCEL_OD,
        Filtres: transform(this.lastPayload),
      };
    },
  },
  methods: {
    ...operationDiverse.mapActions({
      actionsloadOperationDiverse: 'loadOperationDiverse',
    }),
    ...societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    async reinitialiserFiltre() {
      await this.$refs.filtreListeOperationDiverse.initializeFiltre();
      await this.$refs.filtreListeOperationDiverse.viderCritere();
      await this.$refs.filtreListeOperationDiverse.appliquerCritere();
      this.showFiltre = false;
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeOperationDiverse.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    selectAll() {
      const select = !this.allOdSelected;
      this.items.forEach(item => {
        item.selected = select;
      });
    },
    getAllOdSelected() {
      return this.items.filter((el) => {
        return el.selected;
      });
    },
    getEtat(codeEtat) {
      const etatFind = LISTE_ETAT_OD.find((etat) => {
        return etat.value === codeEtat;
      });
      return etatFind ? etatFind.libelle : null;
    },
    manageActions(action) {
      if (action === ACTION_MASS_DELETE) {
        if (this.checkPermissions(this.permOperationDiverse.supprimer)) {
          this.messagesPopUp = [];
          this.isErrorPopUp = false;
          this.popUpSuppression = true;
          this.idToDelete = this.items.filter((el) => {
            return el.selected;
          }).map((el) => { return el.id; });
        } else this.showPopUp();
      }
    },
    openPopUpDelete(od) {
      this.popUpSuppression = true;
      this.idToDelete = [od.id];
      this.messagesPopUp = [];
      this.isErrorPopUp = false;
    },
    async deleteOdMass() {
      this.messagesPopUp = [];
      this.isErrorPopUp = false;
      const loadingComponent = this.$buefy.loading.open();
      try {
        await deleteAll(this.idToDelete);
        this.popUpSuppression = false;
        messageSucces(this.idToDelete.length === 1
          ? this.$t('listeOperationDiverse.messages.successSuppression') : this.$t('listeOperationDiverse.messages.successSuppressionMulti'));
        loadingComponent.close();
        this.recherche();
      } catch (e) {
        if (e.response && e.response.data.error) {
          this.isErrorPopUp = true;
          validation(e.response, this.messagesPopUp);
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    isClient(tiers) {
      return tiers.sousTypes.includes(TIERS_SOUS_TYPE_AUCUN);
    },
  },
  created() {
    if (this.$route.params.idsOd) {
      this.critereRecherche.odIds = [...new Set(JSON.parse(this.$route.params.idsOd))];
    } else {
      this.critereRecherche.odIds = [];
    }
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, this.goFirstPage);
      this.setInformationPage(this.$t('pageCompta.operationDiverse.liste'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};

</script>
